/**
 * Stable string keys used in `instruction_details_json.execution_details.details[].key`.
 *
 * These are the contract between:
 * - **Writers**: downstream generators/processors that write an ExecutionDetail
 *   (e.g. `services/file-server/src/generators/disbursement/nacha.generator.ts`
 *   and the CASS 0200 return processor in
 *   `services/file-server/src/processors/return/cass-0200.constants.ts`).
 * - **Readers**: UI surfaces that render rail-specific settlement identifiers
 *   (e.g. the Payment Details modal in `apps/web-app`).
 *
 * Renaming any of these values is a breaking change across services. Keep this
 * file as the single source of truth and reference the constants everywhere.
 */
export const EXECUTION_DETAIL_KEY = {
    /** ACH trace number assigned by the NACHA generator. */
    TRACE_NUMBER: 'trace_number',
    /** Check serial number assigned by the check generator / returned on CASS 0200 check events. */
    CHECK_NUMBER: 'check_number',
    /** Card number (typically masked when surfaced) for virtual/secure/prepaid card rails. */
    CARD_NUMBER: 'card_number',
};
//# sourceMappingURL=execution-detail-constants.js.map